import { IonIcon } from '@ionic/react'
import { chevronDown } from 'ionicons/icons'
import React from 'react'
import { useTranslation } from 'react-i18next'
import { MonthlyReport } from '../utils'
import ReportListCard from './ReportListCard'

interface Props {
	year: string
	reports: MonthlyReport[]
	allReports: MonthlyReport[]
	isCollapsed: boolean
	onToggle: () => void
	onSelectReport: (reportId: number) => void
}

const YearGroup: React.FC<Props> = ({
	year,
	reports,
	allReports,
	isCollapsed,
	onToggle,
	onSelectReport,
}) => {
	const { t } = useTranslation('pages_monthlyReportsList')

	return (
		<div>
			<button
				type='button'
				onClick={onToggle}
				className={`hover flex items-center w-full py-[0.7rem] px-[1rem] rounded-[0.7rem] border-none outline-none cursor-pointer text-left text-text-dark dark:text-white shadow-card ${
					isCollapsed
						? 'bg-white dark:bg-brand-secondary-200-dark'
						: 'bg-brand-primary-200-light dark:bg-brand-primary-200-dark'
				}`}
			>
				<span className='text-[1.3rem] font-bold'>{year}</span>
				<span className='ml-[0.7rem] text-[0.8rem] text-text-grey-200 dark:text-text-grey-100'>
					{t('raporttiaMaara', { count: reports.length })}
				</span>
				<div className='grow' />
				<IonIcon
					className={`text-[1.2rem] text-brand-primary-100-light dark:text-brand-primary-100-dark transition-transform duration-200 ease-in-out ${
						isCollapsed ? '-rotate-90' : ''
					}`}
					icon={chevronDown}
				/>
			</button>

			{!isCollapsed && (
				<div className='flex flex-col gap-2 mt-2'>
					{reports.map(report => (
						<ReportListCard
							key={report.id}
							report={report}
							allReports={allReports}
							onClick={() => onSelectReport(report.id)}
						/>
					))}
				</div>
			)}
		</div>
	)
}

export default YearGroup
